export default function ClientMusic() {
  return (
    <section className="flex flex-col gap-4 align-middle items-center">
      <h1>Music Page</h1>
      <p>Coming Soon</p>
    </section>
  );
}
